import { TableCell, TableHead, TableRow } from "@mui/material";
import { TableItem } from "./RopTable";

type RopTableHeaderProps = {
  itemsHeaders: TableItem[];
};

export default function RopTableHeader(props: RopTableHeaderProps) {
  return (
    <TableHead>
      <TableRow>
        {props.itemsHeaders.map((item, i) => (
          <TableCell
            key={i}
            sx={{
              fontWeight: "700",
              width: item.width,
              display: {
                xs: item.isMobile ? "table-cell" : "none",
                md: "table-cell",
              },
            }}
            align={item.align}
          >
            {item.item}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
